import { render, staticRenderFns } from "./app-bind-account.vue?vue&type=template&id=c24705ea&scoped=true&"
import script from "./app-bind-account.vue?vue&type=script&lang=js&"
export * from "./app-bind-account.vue?vue&type=script&lang=js&"
import style0 from "./app-bind-account.vue?vue&type=style&index=0&id=c24705ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24705ea",
  null
  
)

export default component.exports